import React, {useEffect, useState} from 'react'
import { Box, Button, Typography, Modal } from '@mui/material';
import Swal from 'sweetalert2';
import { encryptFormData} from '../../utils/crypt-module/encrypt';
import withReactContent from 'sweetalert2-react-content';
import { dashboardActions } from '../../redux-utils/actions/dashboard-actions';
import { useAuth } from '../../custom-hooks/useAuth';
import { connect } from 'react-redux';
import Loader from '../Loader';
import { useTranslation } from 'react-i18next';


const { participantUpdateAction } = dashboardActions;


function EditMedicalInfo ({
    handleClose, 
    open, 
    style, 
    participant, 
    participantUpdateState, 
    participantUpdateDispatchAction, 
    handleUpdateInfo}) {
 
const ReactSwal = withReactContent(Swal);

 //handle input validations
 const editFormInputObject = {
    father:'',
    mother:'',
    landline:'',
    mobile:'',
    fallback_contact:'',
    fallback_number:'',
    vaccination_fsme:'',
    vaccination_fsme_year:'',
    vaccination_tetanus:'',
    vaccination_tetanus_year:'',
    tick_removal_allowed:'',
    allergies:'',
    food_intolerance:'',
    medication_allowed:'',
    medication:'',
    additional_details:''
 }

 const { t } = useTranslation();


 const { getLogin } = useAuth();
 const loginStorage = JSON.parse(getLogin());

 const [updatedParticipantInput, setUpdatedParticipantInput] = useState(editFormInputObject);
 const [errors, setErrors] = useState({});


 const required_fields = ["father","mother", "landline","mobile","fallback_contact","fallback_number", 
    "vaccination_fsme", "vaccination_tetanus",
    "tick_removal_allowed", "allergies", "food_intolerance", "medication_allowed","medication"];
 
 useEffect(() => {
    setUpdatedParticipantInput(participant)
 }, [participant]);


 const validateInputs = () => {
    let newErrors = {};

    if (updatedParticipantInput.vaccination_fsme === 'yes' && !updatedParticipantInput.vaccination_fsme_year) {
        newErrors.vaccination_fsme_year = 'This field is required';
      }
    
    if (updatedParticipantInput.vaccination_tetanus === 'yes' && !updatedParticipantInput.vaccination_tetanus_year) {
        newErrors.vaccination_tetanus_year = 'This field is required';
    }

    required_fields.forEach(field => {
      if (!updatedParticipantInput[field]) {
        newErrors[field] = 'This field is required';
      }
    });

    if (updatedParticipantInput.email && !/\S+@\S+\.\S+/.test(updatedParticipantInput.email)) {
      newErrors.email = 'Email is invalid';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

 const handleInputChange = (e) => {
    const {name , value}  = e.target;

    setUpdatedParticipantInput({
        ...updatedParticipantInput,
        [name]: value
    });
 }

 const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateInputs()) {
        return;
    } else {
        if(updatedParticipantInput){
           
            const params = {
                publicKey: process.env.REACT_APP_PUB_KEY_1,
                formData:updatedParticipantInput
            }
            //encrypt form data 
           encryptFormData(params)
            .then((encryptedData) => {
                const form_data = {
                    id: updatedParticipantInput.id,
                    token: loginStorage && loginStorage.loginData.data.token,
                    ...encryptedData
                }
                participantUpdateDispatchAction(form_data);
            })
        }
    }
  };

  useEffect(() => {

    if(participantUpdateState.status === "participant_update_success"){
        handleClose();
        ReactSwal.fire({
            title: `${t('swal-messages.Success')}!`,
            text: `${t('swal-messages.Participant')} ${t('swal-messages.Updated')} ${t('swal-messages.Successfully')}!`,
            icon: 'success',
        })
    }
    
    if(participantUpdateState.status === "participant_update_failed") {
        handleClose();
        ReactSwal.fire({
            title: `${t('swal-messages.Error')}!`,
            text: `${t('swal-messages.There was a problem')} ${t('swal-messages.Updating')} ${t('swal-messages.The participant')}!`,
            icon: 'error',
            confirmButtonText: 'OK'
        })
    }

    const updateInfo = {
        updateStatus: participantUpdateState.status,
        updateData: participantUpdateState.participantUpdateData
    }
    handleUpdateInfo(updateInfo);

  }, [participantUpdateState.status])


  return (
    <>
        <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className='-z-50 relative'
        >
            <Box sx={style}>
            {participantUpdateState.status === "participant_update_start" && <Loader componentType="edit-participant-modal" />}
            <form  action="" onSubmit={handleSubmit}>
                <div className="w-full h-[85vh] rounded-lg bg-white p-10 pt-0 overflow-auto relative">
                    <div className="flex justify-between items-center w-auto bg-white h-20 sticky top-0"> 
                        <Typography 
                        variant="h4" 
                        sx={{ 
                            color: '#2F4858', 
                            fontWeight: '500',
                            fontSize: '28px' 
                        }}
                        >
                          {participant.first_name} {participant.last_name}
                        </Typography>
                        <div className="flex gap-5 items-center">
                            <Button
                                type="submit"
                                variant="contained"
                                sx={{
                                    backgroundColor: '#FDB315',
                                    px: 3,
                                    py: '0.59rem',
                                    borderRadius: '999px',
                                    color: 'white',
                                    fontWeight: 600,
                                    fontSize: '12px',
                                    '&:hover': {
                                    backgroundColor: '#FDB315',
                                    color: 'white',
                                    }
                                }}
                            >
                                {t('modals.Update')}
                            </Button>
                            <div onClick={handleClose} className='cursor-pointer bg-[#EFEFEF] hover:bg-[#eeeeff] w-10 h-10 flex items-center justify-center rounded-full'>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-4">
                                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                    <path d="M18 6l-12 12" />
                                    <path d="M6 6l12 12" />
                                </svg>
                            </div>
                        </div>
                    </div>
                    <div className="mt-5">
                        <div className="border rounded-lg p-5">
                            <h1 className="text-[16px] text-tertiary font-medium">{t('modals.Edit')} {t('modals.Medical Information')}</h1>
                            <div className="flex gap-5 mt-4">
                                <div className="flex flex-col w-[50%]">
                                    <label className="font-medium text-[14px]">{t('modals.Medication Allowed')}</label>
                                    <select name = "medication_allowed" value={updatedParticipantInput.medication_allowed} onChange={handleInputChange} className="border px-4 mt-1 py-2 w-full text-gray-500 rounded-lg outline-[#FDB315] ">
                                        <option value="">- SELECT-</option>
                                        <option value="yes" selected = {updatedParticipantInput.medication_allowed === 'yes'}>Yes</option>
                                        <option value="no"  selected={updatedParticipantInput.medication_allowed === 'no'}>No</option>
                                    </select>
                                </div>
                                <div className="flex flex-col w-[50%]">
                                    <label className="font-medium text-[14px]">{t('modals.Medication Allowed')}</label>
                                    <select name = "tick_removal_allowed" value={updatedParticipantInput.tick_removal_allowed} onChange={handleInputChange} className="border px-4 mt-1 py-2 w-full text-gray-500 rounded-lg outline-[#FDB315] ">
                                        <option value="">- SELECT-</option>
                                        <option value="yes" selected = {updatedParticipantInput.tick_removal_allowed === 'yes'}>Yes</option>
                                        <option value="no"  selected={updatedParticipantInput.tick_removal_allowed === 'no'}>No</option>
                                    </select>
                                </div>
                            </div>
                            <div className="flex gap-5 mt-3">
                                <div className="flex flex-col w-[50%]">
                                    <label className="font-medium text-[14px]">{t('modals.Vaccination Tetanus')}</label>
                                    <select name = "vaccination_tetanus" value={updatedParticipantInput.vaccination_tetanus} onChange={handleInputChange} className="border px-4 mt-1 py-2 w-full text-gray-500 rounded-lg outline-[#FDB315] ">
                                        <option value="">- SELECT-</option>
                                        <option value="yes" selected = {updatedParticipantInput.vaccination_tetanus === 'yes'}>Yes</option>
                                        <option value="no"  selected={updatedParticipantInput.vaccination_tetanus === 'no'}>No</option>
                                    </select>
                                </div>
                                <div className="flex flex-col w-[50%]">
                                    <label className="font-medium text-[14px]">{t('modals.Vaccination Tetanus Year')}</label>
                                    <input type="text" onChange={handleInputChange}   name = "vaccination_tetanus_year" value={`${updatedParticipantInput.vaccination_tetanus_year ?? 'N/A'}`} className="border px-4 mt-1 py-2 w-full text-gray-500 rounded-lg outline-[#FDB315] "/>
                                    <div>
                                        {errors.vaccination_tetanus_year && <span className="text-red-500 text-xs">{errors.vaccination_tetanus_year}</span>}
                                    </div>
                                </div>
                            </div>
                            <div className="flex gap-5 mt-3">
                                <div className="flex flex-col w-[50%]">
                                    <label className="font-medium text-[14px]">{t('modals.Vaccination FSME')}</label>
                                    <select name = "vaccination_fsme" value={updatedParticipantInput.vaccination_fsme} onChange={handleInputChange} className="border px-4 mt-1 py-2 w-full text-gray-500 rounded-lg outline-[#FDB315] ">
                                        <option value="">- SELECT-</option>
                                        <option value="yes" selected = {updatedParticipantInput.vaccination_fsme === 'yes'}>Yes</option>
                                        <option value="no"  selected={updatedParticipantInput.vaccination_fsme === 'no'}>No</option>
                                    </select>
                                </div>
                                <div className="flex flex-col w-[50%]">
                                    <label className="font-medium text-[14px]">{t('modals.Vaccination FSME Year')}</label>
                                    <input type="text" onChange={handleInputChange}   name = "vaccination_fsme_year" value={`${updatedParticipantInput.vaccination_fsme_year ?? 'N/A'}`} className="border px-4 mt-1 py-2 w-full text-gray-500 rounded-lg outline-[#FDB315] "/>
                                    <div>
                                        {errors.vaccination_fsme_year && <span className="text-red-500 text-xs">{errors.vaccination_fsme_year}</span>}
                                    </div>
                                </div>
                            </div>
                            <div className="flex gap-5 mt-4">
                                <div className="flex flex-col w-[50%]">
                                    <label className="font-medium text-[14px]">{t('modals.Father\'s Full Name')}</label>
                                    <input type="text" name = "father" value={`${updatedParticipantInput.father ?? 'N/A'}`} onChange={handleInputChange} className="border px-4 mt-1 py-2 w-full text-gray-500 rounded-lg outline-[#FDB315] "/>
                                    <div>
                                        {errors.father && <span className="text-red-500 text-xs">{errors.father}</span>}
                                    </div>
                                </div>
                                <div className="flex flex-col w-[50%]">
                                    <label className="font-medium text-[14px]">{t('modals.Mother\'s Full Name')}</label>
                                    <input type="text" onChange={handleInputChange} name  = "mother" value={`${updatedParticipantInput.mother ?? 'N/A'}`} className="border px-4 mt-1 py-2 w-full text-gray-500 rounded-lg outline-[#FDB315] "/>
                                    <div>
                                        {errors.mother && <span className="text-red-500 text-xs">{errors.mother}</span>}
                                    </div>
                                </div>
                            </div>                               
                            <div className="flex gap-5 mt-3">
                                <div className="flex flex-col w-[50%]">
                                    <label className="font-medium text-[14px]">{t('modals.Landline')}</label>
                                    <input type="text" onChange={handleInputChange}  name = "landline" value={`${updatedParticipantInput.landline ?? 'N/A'}`} className="border px-4 mt-1 py-2 w-full text-gray-500 rounded-lg outline-[#FDB315] "/>
                                    <div>
                                        {errors.landline && <span className="text-red-500 text-xs">{errors.landline}</span>}
                                    </div>
                                </div>
                                <div className="flex flex-col w-[50%]">
                                    <label className="font-medium text-[14px]">{t('modals.Mobile')}</label>
                                    <input type="text" onChange={handleInputChange}  name = "mobile" value={`${updatedParticipantInput.mobile ?? 'N/A'}`} className="border px-4 mt-1 py-2 w-full text-gray-500 rounded-lg outline-[#FDB315] "/>
                                    <div>
                                        {errors.mobile && <span className="text-red-500 text-xs">{errors.mobile}</span>}
                                    </div>
                                </div>
                            </div> 
                            <div className="flex gap-5 mt-4">
                                    <div className="flex flex-col w-[50%]">
                                        <label className="font-medium text-[14px]">{t('modals.Emergency Contact')}</label>
                                        <input type="text" onChange={handleInputChange}  name = "father" value={`${updatedParticipantInput.fallback_contact ?? 'N/A'}`} className="border px-4 mt-1 py-2 w-full text-gray-500 rounded-lg outline-[#FDB315] "/>
                                        <div>
                                            {errors.father && <span className="text-red-500 text-xs">{errors.father}</span>}
                                        </div>
                                    </div>
                                    <div className="flex flex-col w-[50%]">
                                        <label className="font-medium text-[14px]">{t('modals.Emergency Mobile')}</label>
                                        <input type="text" onChange={handleInputChange}  name = "fallback_number" value={`${updatedParticipantInput.fallback_number ?? 'N/A'}`} className="border px-4 mt-1 py-2 w-full text-gray-500 rounded-lg outline-[#FDB315] "/>
                                        <div>
                                            {errors.fallback_number && <span className="text-red-500 text-xs">{errors.fallback_number}</span>}
                                        </div>
                                    </div>
                                </div>
                                <div className="flex gap-5 mt-4">
                                    <div className="flex flex-col w-[50%]">
                                        <label className="font-medium text-[14px]">{t('modals.Medication')}</label>
                                        <input type="text" onChange={handleInputChange}  name = "medication" value={`${updatedParticipantInput.medication ?? 'N/A'}`} className="border px-4 mt-1 py-2 w-full text-gray-500 rounded-lg outline-[#FDB315] "/>
                                        <div>
                                            {errors.medication && <span className="text-red-500 text-xs">{errors.medication}</span>}
                                        </div>
                                    </div>
                                    <div className="flex flex-col w-[50%]">
                                        <label className="font-medium text-[14px]">{t('modals.Allergies')}</label>
                                        <input type="text" onChange={handleInputChange}  name = "allergies" value={`${updatedParticipantInput.allergies ?? 'N/A'}`} className="border px-4 mt-1 py-2 w-full text-gray-500 rounded-lg outline-[#FDB315] "/>
                                        <div>
                                            {errors.allergies && <span className="text-red-500 text-xs">{errors.allergies}</span>}
                                        </div>
                                    </div>
                                </div>
                                <div className="flex gap-5 mt-4">
                                    <div className="flex flex-col w-[50%]">
                                        <label className="font-medium text-[14px]">{t('modals.Food Intolerance')}</label>
                                        <input type="text" onChange={handleInputChange}  name = "food_intolerance" value={`${updatedParticipantInput.food_intolerance ?? 'N/A'}`} className="border px-4 mt-1 py-2 w-full text-gray-500 rounded-lg outline-[#FDB315] "/>
                                        <div>
                                            {errors.food_intolerance && <span className="text-red-500 text-xs">{errors.food_intolerance}</span>}
                                        </div>
                                    </div>
                                </div>
                                <div className=" mt-4">
                                    <div className="flex flex-col w-full">
                                        <label className="font-medium text-[14px] mt-2">{t('modals.Additional Details')}</label>
                                        <input type="text" onChange={handleInputChange}  name = "additional_details" value={`${updatedParticipantInput.additional_details ?? 'N/A'}`} className="border px-4 mt-1 py-2 w-full text-gray-500 rounded-lg outline-[#FDB315] "/>
                                        <div>
                                            {errors.additional_details && <span className="text-red-500 text-xs">{errors.additional_details}</span>}
                                        </div>
                                    </div>
                                </div> 
                        </div>
                    </div>
                </div>
            </form>
            </Box>
        </Modal>
    </>
  )
}

const mapStateToProps = state => ({
    participantUpdateState: state.dashboardState
})

const mapDispatchToProps = dispatch => ({
    participantUpdateDispatchAction: (params) => dispatch(participantUpdateAction(params)),
})


export default connect(mapStateToProps, mapDispatchToProps)(EditMedicalInfo)